import { createFileRoute } from "@tanstack/react-router"

import { SiftListsView } from "@/features/sift/components/sift-lists-view"
import { siftListsQueryOptions } from "@/features/sift/hooks/use-sift"
import type { ListStatus } from "@/features/sift/types"
import { warm } from "@/lib/router/warm"

const STATUSES: ListStatus[] = ["uploaded", "enriching", "ready", "failed"]

export const Route = createFileRoute("/_shell/sift/lists/")({
  // Both optional: a status view, and `new=1` to open New scrub (the
  // sidebar links to each).
  validateSearch: (
    search: Record<string, unknown>
  ): { status?: ListStatus; new?: "1" } => ({
    status: STATUSES.find((s) => s === search.status),
    new: String(search.new ?? "") === "1" ? "1" : undefined,
  }),
  // Awaited (bounded): the page paints with its data, not skeletons.
  loader: ({ context: { queryClient } }) =>
    warm(queryClient, [
      siftListsQueryOptions(),
    ]),
  component: SiftListsRoute,
})

function SiftListsRoute() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <SiftListsView
      status={search.status ?? "all"}
      onStatusChange={(next) =>
        void navigate({
          search: (prev) => ({
            ...prev,
            status: next === "all" ? undefined : next,
          }),
          replace: true,
          resetScroll: false,
        })
      }
      newOpen={search.new === "1"}
      onNewOpenChange={(open) =>
        void navigate({
          search: (prev) => ({ ...prev, new: open ? "1" : undefined }),
          replace: !open,
          resetScroll: false,
        })
      }
    />
  )
}
